<template>
  <div
    class="input"
    :class="{ input_disabled: disabled }"
  >
    <input
      v-model="c_value"
      v-maska
      class="input__input input__input_filled"
      :class="c_inputClass"
      :placeholder="placeholder"
      :data-maska="mask"
    />
    <label
      v-if="label"
      class="input__label"
    >
      {{ label }}
    </label>
    <slot />
  </div>
</template>

<script>
import { vMaska } from 'maska';

export default {
  name: 'MaskedInput',
  directives: { maska: vMaska },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: undefined,
    },
    error: {
      type: [String, Boolean, Array],
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: [Object, String],
      required: true,
    },
    unstyled: {
      type: Boolean,
      default: false,
    },
  },
  // components: {
  //     TheMask,
  // },
  emits: ['update:modelValue'],
  data() {
    return {
      rawVal: null,
    };
  },
  computed: {
    c_error() {
      if (Array.isArray(this.error)) {
        return this.error.length;
      } else {
        return this.error;
      }
    },
    c_inputClass() {
      const res = [];
      if (this.c_error) {
        res.push('masked-input__input_error');
      }
      if (!this.label) {
        res.push('masked-input__no-label');
      }
      return res.join(' ');
    },
    c_value: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', `${val}`);
      },
    },
  },
  mounted() {
    if (this.disabled) {
      this.$el.querySelector('input').disabled = true;
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style lang="scss">
.masked-input__no-label {
  padding: 15px;
}
.masked-input__no-label:focus {
  padding: 15px;
}
</style>
